import axios from 'axios'
import config from '../config'
import { getDoctorToken } from "../utils"

const getContainerListApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}emergency-dtrf${params.dropDownList}`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
    })
    return response

}

export default getContainerListApi